<template>
  <div class="w-full mx-auto px-4 py-8 lg:px-8">
    <div v-if="loading >= 2 && !errorMessage" class="max-w-6xl mx-auto">
      <section
        class="bg-white rounded-2xl p-5 sm:p-6 lg:p-8 shadow-sm border border-slate-100 mb-8 sm:mb-10"
      >
        <div class="flex flex-col lg:flex-row gap-8 lg:gap-10 items-start">
          <div class="flex-1 space-y-6">
            <div class="flex items-start gap-3 sm:gap-4">
              <div
                class="w-14 h-14 sm:w-16 sm:h-16 lg:w-20 lg:h-20 rounded-2xl bg-slate-100 overflow-hidden flex items-center justify-center"
              >
                <img
                  :src="
                    profile?.profileImage ||
                    require('/assets/images/logo_comect.png')
                  "
                  alt="Logo"
                  class="w-full h-full object-cover"
                />
              </div>
              <div class="space-y-1 min-w-0">
                <div class="flex items-center gap-2">
                  <h1
                    class="text-xl sm:text-2xl lg:text-3xl font-bold truncate"
                  >
                    {{ profile?.name }}
                  </h1>
                  <!--
                  <img
                    :src="require('/assets/images/Certif.png')"
                    alt="Certif"
                    class="h-5 w-5 lg:h-6 lg:w-6"
                  />
                  -->
                </div>
                <p
                  class="text-xs sm:text-sm text-slate-500 font-mono break-all"
                >
                  DID:{{ formatDid(did) }}
                </p>
              </div>
            </div>

            <div class="flex flex-wrap gap-3">
              <button
                v-if="invitationLink"
                @click="showDynamicQrCode = true"
                class="bg-[#4030C6] text-white px-6 sm:px-8 py-2.5 rounded-lg font-semibold shadow-sm hover:opacity-90 transition-opacity w-full sm:w-auto"
              >
                Join Community
              </button>
              <button
                @click="shareCommunity"
                class="flex items-center gap-2 px-6 sm:px-8 py-2.5 bg-white border border-slate-200 rounded-lg font-semibold shadow-sm hover:bg-slate-50 transition-colors w-full sm:w-auto text-slate-700"
              >
                <i class="fas fa-share-alt text-slate-500"></i>
                Share
              </button>
            </div>

            <div
              v-if="
                templateLists &&
                templateLists['Membership'] &&
                templateLists['Membership'][0]
              "
              class="flex flex-wrap gap-4 text-sm"
            >
              <div class="flex items-center gap-2 text-slate-700">
                <icon name="user-group" class="fill-slate-500 h-4 w-4" />
                <span class="font-semibold">{{ memberCount }}</span>
                <span>Members</span>
              </div>
              <div class="flex items-center gap-2 text-slate-700">
                <icon name="badge-basic" class="fill-slate-500 h-4 w-4" />
                <span class="font-semibold">{{
                  Object.values(templateLists)
                    .filter((list) => list !== templateLists['Membership'])
                    .flatMap((list) => list).length
                }}</span>
                <span>Badges</span>
              </div>
              <div
                v-if="createdDate"
                class="flex items-center gap-2 text-slate-500 text-sm"
              >
                <span>Created {{ formatDate(createdDate) }}</span>
              </div>
            </div>

            <div v-if="profile?.description" class="pt-2">
              <p
                class="text-xs font-bold uppercase tracking-widest text-slate-400"
              >
                Description
              </p>
              <p class="text-slate-600 mt-2 leading-relaxed">
                {{ profile?.description }}
              </p>
            </div>

            <div class="flex flex-wrap gap-2 pt-2">
              <span
                class="px-3 py-1 bg-slate-50 border border-slate-200 text-slate-700 rounded-full text-xs font-bold uppercase tracking-wider"
              >
                {{ profile?.sector || 'Community' }}
              </span>
            </div>
          </div>

          <div
            v-if="membershipTemplate"
            class="w-full flex justify-center lg:justify-end lg:w-auto"
          >
            <TemplatePreview
              :templateImage="membershipTemplate.image"
              :templateName="membershipTemplate.name"
              :templateLocation="
                membershipTemplate.type === 'participation'
                  ? membershipTemplate.location.split(', ')[0] || 'Virtual'
                  : null
              "
              :templateStartDate="
                membershipTemplate.type === 'participation'
                  ? membershipTemplate.startDate
                  : null
              "
              :templateEndDate="
                membershipTemplate.type === 'participation'
                  ? membershipTemplate.endDate
                  : null
              "
              :templateThemeBgColor="
                membershipTemplate.badgeTheme
                  ? membershipTemplate.badgeTheme.backgroundCardColor
                  : null
              "
              :templateThemeTextColor="
                membershipTemplate.badgeTheme
                  ? membershipTemplate.badgeTheme.textColor
                  : null
              "
              :templateThemeEffect="
                membershipTemplate.badgeTheme
                  ? membershipTemplate.badgeTheme.cardEffect
                  : null
              "
              :templateThemeTexture="
                membershipTemplate.badgeTheme
                  ? membershipTemplate.badgeTheme.textureImageURL
                  : null
              "
              :templateThemeIsLogoBack="
                membershipTemplate.badgeTheme
                  ? membershipTemplate.badgeTheme.isLogoBack
                  : null
              "
              :templateThemeShape="
                membershipTemplate.badgeTheme
                  ? membershipTemplate.badgeTheme.shape
                  : null
              "
              :issuerName="profile.name"
              :issuerImage="profile.profileImage"
              :formatSm="false"
              :type="membershipTemplate.badgeCategory"
              :is3d="false"
              class="hidden md:block"
            />
            <TemplatePreview
              :templateImage="membershipTemplate.image"
              :templateName="membershipTemplate.name"
              :templateLocation="
                membershipTemplate.type === 'participation'
                  ? membershipTemplate.location.split(', ')[0] || 'Virtual'
                  : null
              "
              :templateStartDate="
                membershipTemplate.type === 'participation'
                  ? membershipTemplate.startDate
                  : null
              "
              :templateEndDate="
                membershipTemplate.type === 'participation'
                  ? membershipTemplate.endDate
                  : null
              "
              :templateThemeBgColor="
                membershipTemplate.badgeTheme
                  ? membershipTemplate.badgeTheme.backgroundCardColor
                  : null
              "
              :templateThemeTextColor="
                membershipTemplate.badgeTheme
                  ? membershipTemplate.badgeTheme.textColor
                  : null
              "
              :templateThemeEffect="
                membershipTemplate.badgeTheme
                  ? membershipTemplate.badgeTheme.cardEffect
                  : null
              "
              :templateThemeTexture="
                membershipTemplate.badgeTheme
                  ? membershipTemplate.badgeTheme.textureImageURL
                  : null
              "
              :templateThemeIsLogoBack="
                membershipTemplate.badgeTheme
                  ? membershipTemplate.badgeTheme.isLogoBack
                  : null
              "
              :templateThemeShape="
                membershipTemplate.badgeTheme
                  ? membershipTemplate.badgeTheme.shape
                  : null
              "
              :issuerName="profile.name"
              :issuerImage="profile.profileImage"
              :formatSm="true"
              :type="membershipTemplate.badgeCategory"
              :is3d="true"
              class="md:hidden"
            />
          </div>
        </div>

        <div
          v-if="socialMedia.length > 0"
          class="mt-8 pt-6 border-t border-slate-100"
        >
          <h3 class="text-lg font-bold mb-4">Social</h3>
          <div class="flex flex-wrap gap-3">
            <template v-for="(social, index) in socialMedia" :key="index">
              <a
                v-if="social.value"
                :href="social.value"
                target="_blank"
                class="flex items-center gap-2 px-4 py-2 bg-slate-50 border border-slate-200 rounded-full text-sm font-medium hover:border-[#4030C6] transition-colors"
              >
                <icon
                  :name="social.name"
                  class="fill-black w-4 h-4"
                  :class="{
                    'fill-indigo-700': social.name == 'website',
                    '!fill-[#7289da]': social.name == 'discord',
                  }"
                />
                <span>{{
                  social.name[0].toUpperCase() + social.name.slice(1)
                }}</span>
              </a>
            </template>
          </div>
        </div>
      </section>

      <section class="mb-10 sm:mb-12">
        <div class="flex items-end justify-between mb-6">
          <div>
            <h2 class="text-xl sm:text-2xl font-bold">Latest badges</h2>
            <p class="text-xs sm:text-sm text-slate-500">
              Recent achievements and collectibles from the community
            </p>
          </div>
        </div>
        <div
          v-if="lastTemplates && profile"
          class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2"
        >
          <div
            v-for="(template, index) in lastTemplates"
            :key="index"
            class="flex justify-center"
          >
            <div class="scale-[1.05] sm:scale-[1.08] origin-top">
              <TemplatePreview
                :ref="(el) => setBadgeRef(el, index)"
                @click="onBadgeClick(index)"
                :templateImage="template.data.image"
                :templateName="template.data.name"
                :templateLocation="
                  template.data.type === 'participation'
                    ? template.data.location.split(', ')[0] || 'Virtual'
                    : null
                "
                :templateStartDate="
                  template.data.type === 'participation'
                    ? template.data.startDate
                    : null
                "
                :templateEndDate="
                  template.data.type === 'participation'
                    ? template.data.endDate
                    : null
                "
                :templateThemeBgColor="
                  template.data.badgeTheme
                    ? template.data.badgeTheme.backgroundCardColor
                    : null
                "
                :templateThemeTextColor="
                  template.data.badgeTheme
                    ? template.data.badgeTheme.textColor
                    : null
                "
                :templateThemeEffect="
                  template.data.badgeTheme
                    ? template.data.badgeTheme.cardEffect
                    : null
                "
                :templateThemeTexture="
                  template.data.badgeTheme
                    ? template.data.badgeTheme.textureImageURL
                    : null
                "
                :templateThemeIsLogoBack="
                  template.data.badgeTheme
                    ? template.data.badgeTheme.isLogoBack
                    : null
                "
                :templateThemeShape="
                  template.data.badgeTheme
                    ? template.data.badgeTheme.shape
                    : null
                "
                :issuerName="profile.name"
                :issuerImage="profile.profileImage"
                :formatSm="true"
                :type="template.data.badgeCategory"
                :is3d="true"
              />
            </div>
          </div>
        </div>
      </section>
    </div>

    <div
      v-else-if="loading < 2 && !errorMessage"
      class="flex justify-center items-center"
    >
      <div class="flex justify-center mb-5">
        <Vue3Lottie
          :animationLink="require('/assets/images/loader-round.jpg')"
          :height="100"
          :width="100"
          :speed="1.5"
        />
      </div>
    </div>
    <div v-else-if="errorMessage">
      <p>{{ errorMessage }}</p>
    </div>

    <div v-if="showDynamicQrCode">
      <div
        @click="showDynamicQrCode = false"
        class="fixed inset-0 z-40 flex justify-center items-center p-4 bg-black/50 backdrop-blur-sm"
      >
        <div
          @click.stop
          class="relative w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl border border-slate-100"
        >
          <!-- Close button -->
          <button
            @click="showDynamicQrCode = false"
            class="absolute top-4 right-4 z-10 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
            aria-label="Close"
          >
            <i class="fas fa-times text-lg"></i>
          </button>

          <!-- Header with avatar -->
          <div class="bg-gradient-to-br from-[#eff6ff] to-white px-6 pt-6 pb-4">
            <div class="flex items-center gap-4">
              <div
                class="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-slate-100 overflow-hidden flex-shrink-0 border-2 border-white shadow-md"
              >
                <img
                  :src="
                    profile?.profileImage ||
                    require('/assets/images/logo_comect.png')
                  "
                  :alt="profile?.name"
                  class="w-full h-full object-cover"
                />
              </div>
              <div class="min-w-0 flex-1">
                <h2 class="text-xl font-bold text-slate-900 truncate">
                  Join {{ profile?.name || 'the community' }}
                </h2>
                <p class="text-xs text-slate-500 mt-0.5">
                  Scan the QR code to join instantly
                </p>
              </div>
            </div>
          </div>

          <div class="px-6 pb-6">
            <p class="text-sm text-slate-600 mb-5">
              This link is unique to the community. Use the myDid app to scan
              and join.
            </p>
            <div
              class="flex justify-center mb-5 rounded-xl bg-slate-50 border border-slate-100 p-5"
            >
              <qrcode-vue
                :value="invitationLink"
                :size="220"
                level="L"
                :margin="1"
              />
            </div>
            <div
              class="flex items-center gap-2 rounded-xl bg-slate-50 border border-slate-200 px-4 py-3"
            >
              <a
                :href="invitationLink"
                target="_blank"
                rel="noopener noreferrer"
                class="text-xs text-[#4030C6] break-all flex-1 hover:underline font-medium"
                @click.stop
              >
                {{ invitationLink }}
              </a>
              <button
                @click.stop="copyLink"
                class="shrink-0 px-3 py-2 text-xs font-semibold rounded-lg bg-[#4030C6] text-white hover:bg-[#4030C6]/90 transition-colors"
              >
                {{ linkCopied ? 'Copied!' : 'Copy' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Share Fallback Modal -->
    <Teleport to="body">
      <div
        v-if="showShareModal"
        class="fixed inset-0 z-50 flex items-center justify-center"
      >
        <div
          class="absolute inset-0 bg-black/40 backdrop-blur-sm"
          @click="showShareModal = false"
        ></div>
        <div
          class="relative bg-white rounded-2xl shadow-2xl p-6 w-[90%] max-w-md mx-4"
        >
          <button
            @click="showShareModal = false"
            class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <i class="fas fa-times text-lg"></i>
          </button>

          <div class="flex items-center gap-3 mb-5">
            <div
              class="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center"
            >
              <i class="fas fa-share-alt text-[#3b82f6]"></i>
            </div>
            <h3 class="text-lg font-bold text-gray-900">Share this community</h3>
          </div>

          <p class="text-sm text-gray-500 mb-4">
            The link has been copied to your clipboard. You can paste it
            anywhere to share.
          </p>

          <div
            class="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-4 py-3"
          >
            <code class="text-sm text-gray-600 font-mono truncate flex-1">{{
              shareUrl
            }}</code>
            <button
              @click="copyShareUrlToClipboard"
              class="shrink-0 p-1.5 hover:bg-gray-200 rounded-lg transition-colors"
            >
              <i class="fas fa-copy text-gray-400"></i>
            </button>
          </div>

          <div
            class="flex items-center gap-2 mt-4 pt-4 border-t border-gray-100"
          >
            <i class="fas fa-check-circle text-[#3b82f6] text-sm"></i>
            <span class="text-sm text-blue-600 font-medium"
              >Link copied to clipboard!</span
            >
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import { ref, inject, onMounted, watch } from 'vue';
import TheFooter from '@/components/TheFooter.vue';
import TemplatePreview from '@/components/TemplatePreview.vue';
import TheHeader from '@/components/TheHeader.vue';
import { useCommunityDetailStore } from '@/store/communityDetail';

export default {
  components: { TheHeader, TemplatePreview, TheFooter },
  setup() {
    const route = useRoute();
    const api = inject('api');
    const utils = inject('utils');
    const communityStore = useCommunityDetailStore();

    const profile = ref(null);
    const socialMedia = ref([]);
    const templateLists = ref(null);
    const lang = ref('en');
    const loading = ref(0);
    const errorMessage = ref(null);
    const memberCount = ref(0);
    const showDynamicQrCode = ref(false);
    const invitationLink = ref('');
    const linkCopied = ref(false);
    const showShareModal = ref(false);
    const shareUrl = ref('');
    const memberShipTemplateHash = ref(null);
    const createdDate = ref(null);
    const lastTemplates = ref(null);
    const membershipTemplate = ref(null);
    const badgeRefs = ref([]);
    const flippedBadgeIndex = ref(null);
    let autoFlipBackTimeout = null;
    const AUTO_FLIP_BACK_DELAY = 3000; // 3 seconds

    const setBadgeRef = (el, index) => {
      if (el) badgeRefs.value[index] = el;
    };

    const clearAutoFlipBack = () => {
      if (autoFlipBackTimeout) {
        clearTimeout(autoFlipBackTimeout);
        autoFlipBackTimeout = null;
      }
    };

    const scheduleAutoFlipBack = () => {
      clearAutoFlipBack();
      autoFlipBackTimeout = setTimeout(() => {
        if (flippedBadgeIndex.value !== null) {
          const comp = badgeRefs.value[flippedBadgeIndex.value];
          if (comp?.flipTemplate) comp.flipTemplate();
          flippedBadgeIndex.value = null;
        }
      }, AUTO_FLIP_BACK_DELAY);
    };

    const onBadgeClick = (index) => {
      clearAutoFlipBack();

      const comp = badgeRefs.value[index];
      if (!comp?.flipTemplate) return;

      if (flippedBadgeIndex.value === index) {
        // Same badge clicked again → flip it back
        comp.flipTemplate();
        flippedBadgeIndex.value = null;
      } else {
        // Different badge → flip previous one back first
        if (flippedBadgeIndex.value !== null) {
          const prevComp = badgeRefs.value[flippedBadgeIndex.value];
          if (prevComp?.flipTemplate) prevComp.flipTemplate();
        }
        // Flip the new one after 100ms
        setTimeout(() => {
          comp.flipTemplate();
          flippedBadgeIndex.value = index;
          scheduleAutoFlipBack();
        }, 10);
      }
    };

    if (route.query.lang) {
      lang.value = route.query.lang;
    }

    const did = ref(route.params.id);

    const formatDid = (value) => {
      if (!value) return '';
      const str = String(value);
      if (str.length <= 18) return str;
      return `${str.slice(0, 10)}...${str.slice(-6)}`;
    };

    const formatDate = (timestamp) => {
      if (!timestamp) return '';
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    };

    const applyData = (data) => {
      if (!data) return;
      profile.value = data.profile || null;
      socialMedia.value = data.socialMedia || [];
      templateLists.value = data.templateLists || null;
      memberCount.value = data.memberCount ?? 0;
      lastTemplates.value = data.lastTemplates || null;
      membershipTemplate.value = data.membershipTemplate || null;
      invitationLink.value = data.invitationLink || '';
      memberShipTemplateHash.value =
        data.templateLists?.['Membership']?.[0]?.templateHash || null;
      createdDate.value = data.createdAt ?? null;
    };

    const loadCommunity = async () => {
      const currentDid = did.value;
      if (!currentDid) return;
      errorMessage.value = null;

      communityStore.loadFromLocalStorage();

      if (communityStore.isCacheValid(currentDid)) {
        const cached = communityStore.getCommunityData(currentDid);
        applyData(cached);
        loading.value = 2;
        return;
      }

      loading.value = 0;
      try {
        const data = await communityStore.fetchCommunity(
          currentDid,
          api,
          utils
        );
        applyData(data);
        loading.value = 2;
      } catch (error) {
        console.error('Error fetching community:', error);
        errorMessage.value = 'Error fetching community details';
        loading.value = 0;
      }
    };

    const copyLink = () => {
      navigator.clipboard.writeText(invitationLink.value).then(() => {
        linkCopied.value = true;
        setTimeout(() => {
          linkCopied.value = false;
        }, 2000);
      });
    };

    const shareCommunity = async () => {
      const url = window.location.href;
      shareUrl.value = url;

      if (navigator.share) {
        try {
          await navigator.share({
            title: profile.value?.name || 'Community',
            text: `Check out this community: ${profile.value?.name || 'Community'}`,
            url: url,
          });
        } catch (err) {
          if (err.name !== 'AbortError') {
            console.error('Share failed:', err);
          }
        }
      } else {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
        }
        showShareModal.value = true;
      }
    };

    const copyShareUrlToClipboard = () => {
      if (navigator.clipboard && window.isSecureContext && shareUrl.value) {
        navigator.clipboard.writeText(shareUrl.value);
      }
    };

    onMounted(() => {
      loadCommunity();
    });

    watch(
      () => route.params.id,
      (newDid) => {
        if (newDid) {
          did.value = newDid;
          loadCommunity();
        }
      }
    );

    return {
      profile,
      lang,
      loading,
      badgeRefs,
      setBadgeRef,
      onBadgeClick,
      did,
      formatDid,
      templateLists,
      memberCount,
      lastTemplates,
      membershipTemplate,
      createdDate,
      errorMessage,
      invitationLink,
      showDynamicQrCode,
      linkCopied,
      copyLink,
      shareCommunity,
      showShareModal,
      shareUrl,
      copyShareUrlToClipboard,
      socialMedia,
      createdDate,
      formatDate,
    };
  },
};
</script>

<style scoped></style>
